export const darkTheme = {
    bg: "#121212",
    bgLight: "#1C1C1C",
    primary: "#635CA9",
    text_primary: "#F2F3F4",
    text_secondary: "#b1b2b3",
    card: "#0D0D0D",
    card_light: "#1A1A1A",
    button: "#635CA9",
    white: "#FFFFFF",
    black: "#000000",
}


export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}